<div class="overlay">
    <mat-icon svgIcon="lock" class="lock-icon"></mat-icon>
    <span trans>{{message}}</span>
</div>
